import { useState }                 from "react";
import { useRouter }                from "next/router";
import { isPageRoute }              from "_common/utils";
import Toast                        from "_common/toast";
import { markAllReadNotifications } from "_services/api/user";
import Presentation                 from "./presentation";
import { storeEvent }               from "_analytics/index";

const Component = props => {

	const {
		anchorEl,
		handleClose = () => {},
		handleClick,
		open,
		notificationCount
	} = props;

	const [ activeTab, setActiveTab ]             = useState ( "ME" ); // for header tabs
	const [ activeUpdateTab, setActiveUpdateTab ] = useState ( "updates" ); // for updates section sub tabs
	const [ openSettings, setOpenSettings ]       = useState ( false );

	const router = useRouter ();

	const isNotificationsPage = isPageRoute ( { router, page: "notifications" } );

	const [ marked, setMarked ] = useState ( 0 );

	const handleGAEvent = ( tab, val ) => {
		if ( tab === "defaultTabs" )
			return storeEvent ( "Notification_clicked", `${ val }_clicked` );

		return storeEvent ( "Notification_clicked", "Updates_clicked", val );
	};

	const changeActiveTab = ( e, newVal ) => {
		handleGAEvent ( "defaultTabs", e );
		setActiveTab ( e );
	};

	const changeUpdateTab = newVal => {
		handleGAEvent ( "", newVal );
		setActiveUpdateTab ( newVal );
	};

	const handleSettingsOpen = () => {
		setOpenSettings ( true );
	};

	const handleSettingsClose = () => {
		setOpenSettings ( false );
	};

	const handleMarkAllRead = async () => {
		try {
			await markAllReadNotifications ();
			setMarked ( 1 );
		} catch ( e ) {
			Toast.error ( e.displayMsg );

			return;
		}
	};

	return (
		<Presentation
			activeTab           = { activeTab }
			activeUpdateTab     = { activeUpdateTab }
			anchorEl            = { anchorEl }
			changeActiveTab     = { changeActiveTab }
			changeUpdateTab     = { changeUpdateTab }
			handleClick         = { handleClick }
			handleClose         = { handleClose }
			handleMarkAllRead   = { handleMarkAllRead }
			handleSettingsClose = { handleSettingsClose }
			handleSettingsOpen  = { handleSettingsOpen }
			isNotificationsPage = { isNotificationsPage }
			marked              = { marked }
			notificationCount   = { notificationCount }
			open                = { open }
			openSettings        = { openSettings }
		/>
	);

};

export default Component;